import { callProxy } from "./api";

export async function checkPackageAvailability(slug, startDate) {
  const query = `?startDate=${startDate}`;
  const res = await callProxy(
    `/api/holiday-package-bookings/${slug}/availability${query}`
  );
  return res.data;
}

export async function fetchPackageBookings(slug) {
  const res = await callProxy(`/api/holiday-package-bookings/${slug}/bookings`);
  return res.data; // [{startDate,endDate}]
}

export async function bookPackage(payload) {
  return callProxy("/api/holiday-package-bookings/book", null, {
    method: "POST",
    body: payload,
  });
}

